module.exports = __webpack_public_path__ + "img/file.c3f705d9.png";